import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { Sun, Moon, BoxArrowRight } from 'react-bootstrap-icons';
import FullLogo from '../img/FullLogoLargeText.png';
import { AuthContext } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';

const NavBar = () => {
  const { token, logout } = useContext(AuthContext);
  const { theme, toggleTheme } = useTheme();

  return (
    <Navbar expand="lg" className="navbar-custom" sticky="top">
      <Container className="navbar-custom__container">
        <Navbar.Brand as={Link} to="/">
          <img
            src={FullLogo}
            className="d-inline-block align-top"
            alt="Garden Sync Logo"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" className="navbar-custom__toggle" />
        <Navbar.Collapse id="basic-navbar-nav" className="navbar-custom__collapse">
          <Nav className="ms-auto align-items-lg-center navbar-custom__nav">
            <Nav.Link as={Link} to="/about">About</Nav.Link>
            <Nav.Link as={Link} to="/shop">Shop</Nav.Link>
            <Nav.Link
              as={Link}
              to="https://community.gardensync.com/communities/groups/garden-sync-community/home"
              target="_blank"
            >
              Forum
            </Nav.Link>
            {token && (
              <>
                <Nav.Link as={Link} to="/app/dashboard">Dashboard</Nav.Link>
                <Nav.Link as={Link} to="/app/settings">Settings</Nav.Link>
              </>
            )}
          </Nav>
          <div className="navbar-custom__actions">
            <Button
              variant="link"
              className="navbar-theme-toggle"
              onClick={toggleTheme}
              aria-label="Toggle theme"
            >
              {theme === 'dark' ? <Sun size={20} /> : <Moon size={20} />}
            </Button>
            {token ? (
              <Button
                variant="outline-danger"
                size="sm"
                className="navbar-logout-btn"
                onClick={() => logout()}
              >
                <BoxArrowRight size={16} className="me-1" />
                Logout
              </Button>
            ) : (
              <Button as={Link} to="/app" className="navbar-cta">
                Login / Register
              </Button>
            )}
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavBar;